import { render, staticRenderFns } from "./LexonNumericComponent.vue?vue&type=template&id=e8cbbdf8&scoped=true&lang=pug"
import script from "./LexonNumericComponent.vue?vue&type=script&lang=ts"
export * from "./LexonNumericComponent.vue?vue&type=script&lang=ts"
import style0 from "./LexonNumericComponent.vue?vue&type=style&index=0&id=e8cbbdf8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8cbbdf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8cbbdf8')) {
      api.createRecord('e8cbbdf8', component.options)
    } else {
      api.reload('e8cbbdf8', component.options)
    }
    module.hot.accept("./LexonNumericComponent.vue?vue&type=template&id=e8cbbdf8&scoped=true&lang=pug", function () {
      api.rerender('e8cbbdf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/forms/fields/LexonNumeric/LexonNumericComponent.vue"
export default component.exports